import { Link, useMatch, useResolvedPath } from 'react-router-dom';
import './navitem.scss';
import { useState } from 'react';

const NavItem = ({ icon: IconComponent, text, to, notAllowed }) => {
  const [isHovered, setIsHovered] = useState(false);

  const resolved = useResolvedPath(to);
  const match = useMatch({ path: resolved.pathname, end: true });

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const isActive = match || isHovered;

  return (
    <Link
      onClick={(e) => {
        if (notAllowed) return e.preventDefault();
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className="nav-link"
      to={to}
    >
      <div className={`nav-item-container ${match ? 'isActive' : ''} ${isHovered ? 'isHovered' : ''}`}>
        <div className="nav-icon">
          <IconComponent />
        </div>
        <h6>{text}</h6>
      </div>
    </Link>
  );
};

export default NavItem;
